
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.822 9.054l-.114-.041-.446-1.087.049-.111c1.35-3.127 1.257-3.22 1.033-3.447l-1.802-1.794a.476.476 0 00-.314-.127c-.102 0-.409 0-3.07 1.23l-.106.049-1.098-.452-.044-.111C13.658 0 13.53 0 13.219 0h-2.545c-.31 0-.451 0-1.611 3.168l-.044.116-1.092.454-.105-.044c-1.8-.775-2.853-1.168-3.127-1.168a.478.478 0 00-.315.125l-1.803 1.8c-.229.23-.324.326 1.098 3.388l.052.113-.447 1.086-.109.043C0 10.33 0 10.454 0 10.78v2.545c0 .326 0 .462 3.177 1.624l.114.041.447 1.082-.048.111c-1.351 3.128-1.265 3.213-1.035 3.447l1.799 1.796a.49.49 0 00.317.127c.1 0 .407 0 3.07-1.23l.106-.05 1.099.453.042.112C10.341 24 10.47 24 10.781 24h2.545c.32 0 .452 0 1.613-3.17l.044-.116 1.094-.451.104.043c1.8.777 2.85 1.17 3.123 1.17.11 0 .241-.05.316-.126l1.807-1.803c.227-.232.322-.326-1.102-3.385l-.053-.115.445-1.08.107-.043C24 13.666 24 13.544 24 13.218v-2.544c0-.327 0-.462-3.178-1.62zM12 16.128A4.13 4.13 0 017.876 12 4.129 4.129 0 0112 7.876 4.128 4.128 0 0116.123 12 4.13 4.13 0 0112 16.128z","fill":"#8E8E92","fill-rule":"nonzero"}})])
          )
        }
      }
    